export default __webpack_public_path__ + "static/media/index.8e094359.less";